import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bell.svg'
import _imports_1 from '@/assets/images/bell-hover.svg'
import _imports_2 from '@/assets/images/check2.svg'
import _imports_3 from '@/assets/images/check2-active.svg'


const _withScopeId = n => (_pushScopeId("data-v-b5ba020e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "bell",
  class: "position-absolute bell-not-active"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "bell active",
  class: "position-absolute"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "quantity position-absolute d-inline-flex text-white justify-content-center align-items-center fw-bold px-2"
}
const _hoisted_6 = {
  key: 1,
  class: "quantity position-absolute d-inline-flex text-white justify-content-center align-items-center fw-bold px-2"
}
const _hoisted_7 = { class: "header d-flex justify-content-between align-items-center text-white" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-box mx-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "20",
    height: "20",
    class: "position-absolute icon"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    width: "20",
    height: "20",
    class: "position-absolute icon-hover"
  })
], -1))
const _hoisted_12 = { class: "me-1 fw-bold" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.414",
  height: "12.414",
  viewBox: "0 0 12.414 12.414"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: "11",
    y2: "11",
    transform: "translate(0.707 0.707)",
    fill: "none",
    stroke: "#fff",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: "11",
    y2: "11",
    transform: "translate(0.707 0.707)",
    fill: "none",
    stroke: "#fff",
    "stroke-width": "2"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "item-container bg-white",
  id: "notification"
}
const _hoisted_17 = { class: "tab-header d-flex justify-content-center align-items-center m-0 p-0 my-3" }
const _hoisted_18 = {
  class: "active fw-bold position-relative text-lg-start text-center",
  style: {"font-size":"13px"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "YELLoop", -1))
const _hoisted_20 = {
  key: 0,
  class: "private-count-lobby position-absolute d-inline-flex text-white justify-content-center align-items-center fw-bold px-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "d-flex justify-content-between" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "not-read rounded-circle position-absolute"
}
const _hoisted_26 = {
  key: 1,
  class: "item-container bg-white",
  id: "notification"
}
const _hoisted_27 = { class: "tab-header d-flex justify-content-center align-items-center m-0 p-0 my-3" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "private-count position-absolute d-inline-flex text-white justify-content-center align-items-center fw-bold px-2"
}
const _hoisted_30 = {
  key: 1,
  class: "private-count position-absolute d-inline-flex text-white justify-content-center align-items-center fw-bold px-2"
}
const _hoisted_31 = {
  key: 2,
  class: "caret-center position-absolute"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = { class: "mb-3" }
const _hoisted_38 = {
  key: 0,
  class: "not-read rounded-circle position-absolute"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "d-flex justify-content-between" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = {
  key: 0,
  class: "not-read rounded-circle position-absolute"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import { AUTH_STORE } from '@/store/constants'
import { Tab } from '@/components/tabs/index.vue'
import { useAuthenticated } from '@/use/authentication'
import { ChangeTime } from '@/constants/datepicker.ts'
import { ROOT_STORE } from '@/store/constants'
import { NOTIFICATION_TYPE, numberWithCommas } from '@/constants/common.ts'
import { Modal } from 'bootstrap'
import { useToast } from 'vue-toastification'
import communitySitePostDeleted from '../toast-error/communitySitePostDeleted.vue'
import ModalConfirmMarkAsRead from '@/components/notification/components/ModalConfirmMarkAsRead.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  fromAdminSite: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const isTouchDevice = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0
const touchHtml = isTouchDevice ? document.querySelector('html') : null
const store = useStore()
const route = useRoute()
const tabs: Array<Tab> = [
  {
    title: translate('community'),
    alias: 'community_notification',
  },
  {
    title: 'YELLoop',
    alias: 'yelloop_notification',
  },
]
const openNotification = ref<boolean>(false)
const tabActive = ref<string>('community_notification')
//TODO: SR10
const notifications = computed(() => store.getters[AUTH_STORE.GETTERS.GET_NOTIFICATIONS])
const notificationsCommunity = computed(() => store.getters[AUTH_STORE.GETTERS.GET_NOTIFICATIONS_COMMUNITY])
const numberUnread = computed(() => store.getters[AUTH_STORE.GETTERS.NUMBER_UNREAD])
const numberUnreadCommunity = computed(() => store.getters[AUTH_STORE.GETTERS.NUMBER_UNREAD_COMMUNITY])
const { authenticated } = useAuthenticated()
const dataDetail = computed(() => store.getters[AUTH_STORE.GETTERS.GET_DETAIL_NOTIFICATIONS])
const modalViewDetail = ref()
const modalConfirmMarkAsRead = ref()
const toast = useToast()
const router = useRouter()

watch(
  () => route.path,
  (newPath, oldPath) => {
    if (newPath && oldPath) {
      const oldLayout = router.resolve({ path: oldPath })?.meta?.layout?.name
      const newLayout = router.resolve({ path: newPath })?.meta?.layout?.name
      // If switch to LayoutSidebarAdmin but layout is different from before → stop
      // Avoid duplicate api calls from layout user -> layout admin or layout admin -> layout user
      const isLayoutAdmin = newLayout === 'LayoutSidebarAdmin' || oldLayout === 'LayoutSidebarAdmin'
      if (isLayoutAdmin && newLayout !== oldLayout) return
    }
    const { fromAdminSite } = props
    // 2022/10/07 CW-TrungNT Fix UAT#4489: SR10 (Ph2-R20221014)
    store.dispatch(AUTH_STORE.ACTIONS.CLEAR_NUMBER_UNREAD_NOTIFICATIONS)
    if (authenticated.value && route.path !== `/${route.path.split('/')[1]}/cancel_yelloop_finished` && route.path !== `/${route.path.split('/')[1]}/reset_mail_finished`) {
      store.dispatch(AUTH_STORE.ACTIONS.SET_NUMBER_UNREAD_YELLOOP, { fromAdminSite })

      if (route?.params?.id) {
        store.dispatch(AUTH_STORE.ACTIONS.SET_NUMBER_UNREAD_COMMUNITY, { id: route?.params?.id, fromAdminSite })
      }
    }
    const notificationFromAdmin = store.getters[AUTH_STORE.GETTERS.GET_NOTIFICATION_FROM_ADMIN]
    if (notificationFromAdmin !== fromAdminSite) {
      store.dispatch(AUTH_STORE.ACTIONS.CLEAR_NOTIFICATION)
    }
  },
  {
    immediate: true,
  }
)
const scrollTop = () => {
  let element = document.querySelector('#notification')
  element.scrollTop = 0
}

const disableScroll = () => {
  document.body.addEventListener('wheel', preventDefault, { passive: false })
  document.body.addEventListener('keydown', preventScrollByKeyDown)
}

watch(
  () => openNotification.value,
  () => {
    const { fromAdminSite } = props
    if (openNotification.value) {
      store.dispatch(AUTH_STORE.ACTIONS.SET_NOTIFICATIONS, { fromAdminSite })
      // 2022/09/28 CW-TienNV Fix for UAT Phase1#4196: SR10 (Ph1-R20220929)
      store.dispatch(AUTH_STORE.ACTIONS.SET_NUMBER_UNREAD_YELLOOP, { fromAdminSite })

      if (route.params?.id) {
        store.dispatch(AUTH_STORE.ACTIONS.SET_NOTIFICATIONS_COMMUNITY, { id: route?.params?.id, fromAdminSite })
        store.dispatch(AUTH_STORE.ACTIONS.SET_NUMBER_UNREAD_COMMUNITY, { id: route?.params?.id, fromAdminSite })
      }
      scrollTop()
      if (touchHtml) {
        touchHtml.classList.add('cancel-scroll')
      }
    } else {
      document.body.classList.remove('modal-open-notice')
      if (touchHtml) {
        touchHtml.classList.remove('cancel-scroll')
      }
    }
  },
  {
    immediate: true,
  }
)

onMounted(async () => {
  window.addEventListener('hidden.bs.modal', function () {
    enableScrollModal()
  })
  modalViewDetail.value = new Modal(document.getElementById('detailNotification'))
  modalConfirmMarkAsRead.value = new Modal(document.getElementById('confirmModalMarkAllAsRead'))
})

const isOpenModal = () => {
  const displayViewDetail = modalViewDetail.value._element.style.display
  const displayConfirmMarkAsRead = modalConfirmMarkAsRead.value._element.style.display
  if ([displayViewDetail, displayConfirmMarkAsRead].includes('block')) return true
  return false
}

const clickOpenNotification = () => {
  if (isOpenModal()) return
  tabActive.value = 'community_notification'
  openNotification.value = false
}

const openMarkAsReadModal = () => {
  modalConfirmMarkAsRead.value.show()
  document.body.classList?.add('modal-open-notice')
  if (document.body.classList?.contains('modal-open-notice')) disableScroll()
}

const clickStop = () => {
  openNotification.value = !openNotification.value
  if (!openNotification.value) tabActive.value = 'community_notification'
}

const preventScrollByKeyDown = (event) => {
  const navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown', 'Tab', 'Sp', ' ']
  if (navigationKeys.includes(event.key)) {
    event.preventDefault()
  }
}
const preventDefault = (e) => {
  e.preventDefault()
  const nestedScrollView = document.querySelector('#detailNotification')
  let scrollAmount = e.deltaY

  const currentScrollTop = nestedScrollView.scrollTop
  if (currentScrollTop + scrollAmount < 0) {
    scrollAmount = -currentScrollTop
  } else if (currentScrollTop + scrollAmount > nestedScrollView.scrollHeight - nestedScrollView.clientHeight) {
    scrollAmount = nestedScrollView.scrollHeight - nestedScrollView.clientHeight - currentScrollTop
  }
  nestedScrollView.scrollTop += scrollAmount
  e.stopPropagation()
}
// }
// 2023.02.02 Redmine #6964
// const disableScrollModal = () => {
//   window.addEventListener('touchmove', preventDefault, { passive: false })
// }
const enableScrollModal = () => {
  document.body.removeEventListener('wheel', preventDefault)
  document.body.classList.remove('modal-open-notice')
  window.removeEventListener('touchmove', preventDefault)
  document.body.removeEventListener('keydown', preventScrollByKeyDown)
}

const handleShowDetail = async (id: string | number, notification_type: string | number) => {
  const { fromAdminSite } = props
  const payload = {
    role: 'community',
    id: route.params?.id,
    id_notification: id,
    notification_type,
    fromAdminSite,
  }
  const apiSuccess = await store.dispatch(AUTH_STORE.ACTIONS.SET_DETAIL_NOTIFICATIONS, payload)
  if (notification_type === NOTIFICATION_TYPE.TYPE) {
    if (!dataDetail.value) {
      modalViewDetail.value.hide()
      toast.error({
        component: communitySitePostDeleted,
      })
    } else if (apiSuccess) {
      showModalDetail()
    }
  } else if (apiSuccess) {
    showModalDetail()
  }
}
const handleShowDetailYelloop = async (id: string | number) => {
  const { fromAdminSite } = props
  try {
    const apiSuccess = await store.dispatch(AUTH_STORE.ACTIONS.SET_DETAIL_NOTIFICATIONS, { role: 'yelloop', id_notification: id, fromAdminSite })
    if (apiSuccess) showModalDetail()
    // eslint-disable-next-line no-empty
  } catch (error) {}
}

const showModalDetail = () => {
  document.body.classList.add('modal-open-notice')
  if (document.body.classList.contains('modal-open-notice')) disableScroll()
  modalViewDetail.value.show()
}
const changeTab = (alias: string): void => {
  tabActive.value = alias
  openNotification.value = false
}

const activeCommunityNotification = computed<boolean>(() => tabActive.value === 'community_notification' && !!route?.params.id)

const fetchNotification = async () => {
  const { fromAdminSite } = props
  if (activeCommunityNotification.value) {
    await Promise.all([
      store.dispatch(AUTH_STORE.ACTIONS.SET_NOTIFICATIONS_COMMUNITY, { id: route?.params?.id, fromAdminSite }),
      store.dispatch(AUTH_STORE.ACTIONS.SET_NUMBER_UNREAD_COMMUNITY, { id: route?.params?.id, fromAdminSite }),
    ])
  } else {
    await Promise.all([store.dispatch(AUTH_STORE.ACTIONS.SET_NOTIFICATIONS, { fromAdminSite }), store.dispatch(AUTH_STORE.ACTIONS.SET_NUMBER_UNREAD_YELLOOP, { fromAdminSite })])
  }

  modalConfirmMarkAsRead.value.hide()
}

const showMarkAllAsReadIcon = computed(() => {
  if (activeCommunityNotification.value) {
    return !!numberUnreadCommunity.value?.unread_notification_count
  }

  return !!numberUnread.value?.total_unread_notification
})

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[!_unref(isMobile) || openNotification.value ? 'hover-image' : ''], "notification cursor-pointer"]),
    onClick: _withModifiers(clickStop, ["stop"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_unref(numberUnread)?.total_unread_notification > 0 && !_unref(route)?.params?.id)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(numberWithCommas)(_unref(numberUnread)?.total_unread_notification)), 1))
        : _createCommentVNode("", true),
      (_unref(numberUnreadCommunity)?.unread_notification_count + _unref(numberUnread)?.total_unread_notification > 0 && _unref(route)?.params?.id)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(numberWithCommas)(_unref(numberUnreadCommunity)?.unread_notification_count + _unref(numberUnread)?.total_unread_notification)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([openNotification.value ? 'active' : '', 'notification-panel shadow position-fixed'])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(translate)('notification')), 1),
        _createElementVNode("div", _hoisted_9, [
          (_unref(showMarkAllAsReadIcon))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _withModifiers(openMarkAsReadModal, ["stop"]),
                class: "d-flex flex-row align-center me-3 bg-white rounded-4 mark-all-read-icon cursor-pointer"
              }, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(translate)('markAllAsRead')), 1)
              ], 8, _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            onClick: _withModifiers(clickOpenNotification, ["stop"])
          }, _hoisted_15, 8, _hoisted_13)
        ])
      ]),
      (!_unref(route)?.params.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                (_unref(numberUnread)?.total_unread_notification > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(numberWithCommas)(_unref(numberUnread)?.total_unread_notification)), 1))
                  : _createCommentVNode("", true),
                _hoisted_21
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['item position-relative', !item.is_read ? 'bg-light' : '']),
                key: item,
                onClick: _withModifiers(() => handleShowDetailYelloop(item?.id), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(ChangeTime)(item?.public_date)), 1)
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass([!item.is_read ? 'fw-bold' : ''])
                }, _toDisplayString(item?.title), 3),
                (!item.is_read)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_22))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_unref(route)?.params.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab, index) => {
                return _createElementVNode("li", {
                  key: tab.title,
                  onClick: ($event: any) => (changeTab(tab.alias)),
                  class: _normalizeClass([
              tabActive.value === tab.alias ? 'active' : '',
              'fw-bold position-relative text-lg-start text-center ',
              index === 0 && 'first-li',
              index === tabs?.length - 1 && 'last-li',
            ])
                }, [
                  _createTextVNode(_toDisplayString(tab.title) + " ", 1),
                  (_unref(numberUnreadCommunity)?.unread_notification_count > 0 && index === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(numberWithCommas)(_unref(numberUnreadCommunity)?.unread_notification_count)), 1))
                    : _createCommentVNode("", true),
                  (_unref(numberUnread)?.total_unread_notification > 0 && index === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(numberWithCommas)(_unref(numberUnread)?.total_unread_notification)), 1))
                    : _createCommentVNode("", true),
                  (tabActive.value === tab.alias)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_28)
              }), 64))
            ]),
            (tabActive.value === 'community_notification')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationsCommunity), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(['item position-relative', !item.is_read ? 'bg-light' : '']),
                      key: item,
                      onClick: _withModifiers(($event: any) => (handleShowDetail(item?.id, item?.notification_type)), ["stop"])
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(ChangeTime)(item?.created_at)), 1)
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass([!item.is_read ? 'fw-bold' : ''])
                      }, _toDisplayString(item?.title), 3),
                      (!item.is_read)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_35))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (tabActive.value === 'yelloop_notification')
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(['item position-relative', !item.is_read ? 'bg-light' : '']),
                      key: item,
                      onClick: _withModifiers(($event: any) => (handleShowDetailYelloop(item?.id)), ["stop"])
                    }, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(ChangeTime)(item?.public_date)), 1)
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass([!item.is_read ? 'fw-bold' : ''])
                      }, _toDisplayString(item?.title), 3),
                      (!item.is_read)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_40))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ModalConfirmMarkAsRead, {
        "from-admin-site": __props.fromAdminSite,
        "active-community-notification": _unref(activeCommunityNotification),
        onAfterMarkAsRead: fetchNotification
      }, null, 8, ["from-admin-site", "active-community-notification"])
    ]))
  ], 10, _hoisted_1)), [
    [_directive_click_away, clickOpenNotification]
  ])
}
}

})